import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from '@tanstack/react-query';
import { getHeaders } from "../../../helpers/helper";
import axiosInstance from "../../../shared/config/axiosInstance";
import { QueryKeys } from "../../../shared/react-query/queryKeys";

async function fetchProducts(getAccessTokenSilently: any): Promise<any> {
  const headers = await getHeaders(getAccessTokenSilently);
  
  const { data } = await axiosInstance.get('/admin/GetProducts', {
    headers
  })

  return data;
}

export const useProducts = () => {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery({
    queryKey: [QueryKeys.PRODUCTS],
    queryFn: () => fetchProducts(getAccessTokenSilently),
    enabled: !!getAccessTokenSilently,
    staleTime: 0, // Set to 0 so data is always considered stale
    refetchOnMount: true, // Always refetch when component mounts
  });
};